export default __webpack_public_path__ + "static/media/artist_frame.3ca2ee37.svg";